/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from "react";
import BaseIcon from "../../BaseIcon";

export default class NoResultsIcon extends BaseIcon {
  getChildren = () => {
    const color =
      this.getColor() === "currentColor" ? "#e45785" : this.getColor();
    return [
      <path
        fill={color}
        fillRule={"evenodd"}
        d="M60.56,53.77a2,2,0,0,1,0,2.82L57.8,59.4a1.94,1.94,0,0,1-2.78,0L42.59,46.85a2,2,0,0,1-.16-.24A25,25,0,1,1,47.7,41a1.86,1.86,0,0,1,.42.29ZM41.83,12.14a21,21,0,1,0,0,29.71A21,21,0,0,0,41.83,12.14ZM34,25c-1.66,0-3-1.79-3-4s1.34-4,3-4,3,1.79,3,4S35.66,25,34,25ZM20,25c-1.66,0-3-1.79-3-4s1.34-4,3-4,3,1.79,3,4S21.66,25,20,25Z"
      />
    ];
  };
  getViewBox = () => "0 0 64 64";
}
